import { createSlice } from "@reduxjs/toolkit";
const persistedStore = localStorage.getItem("storeState");
const parsedStore = persistedStore ? JSON.parse(persistedStore) : {};
const selectedStoreSlice = createSlice({
  name: "store",
  initialState: {
    selectedStore: parsedStore.selectedStore || null,
    loading: false,
    error: "",
    items: [],
  },
  reducers: {
    loadStoreLoading(state) {
      state.loading = true;
      state.error = "";
    },
    loadStoreSuccess(state, action) {
      state.selectedStore = action.payload;
      state.loading = false;
    },
    loadStoreError(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    getItemsLoading(state, action) {
      state.loading = true;
    },
    getItemsSuccess(state, action) {
      state.loading = false;
      state.items = action.payload;
    },
    getItemsError(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  loadStoreLoading,
  loadStoreSuccess,
  loadStoreError,
  getItemsLoading,
  getItemsSuccess,
  getItemsError,
} = selectedStoreSlice.actions;
export default selectedStoreSlice.reducer;
